import { WorkInSumTitles } from 'constantsProject';
import type { WorkOrderVersionPriceData } from 'gql/graphql';
import { WorkOrderStatusEnum } from 'gql/graphql';
import { formatNumberToRu } from 'utils';
import { ColoredColumnTitle } from 'utils/tableCells';

import React, { useMemo } from 'react';

const style = { background: 'rgba(186, 157, 245, 0.1)' };

export const useWorkOrderVersionTypeWorkColumns = (workOrderStatus?: WorkOrderStatusEnum) =>
    useMemo(
        () => [
            {
                title: (
                    <ColoredColumnTitle align="left" style={style}>
                        Виды работ
                    </ColoredColumnTitle>
                ),
                accessor: 'groupName',
                align: 'left',
                columns: [
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                Шифр
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workCode',
                        width: 136,
                        className: 'type-work',
                    },
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                Наименование
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workName',
                        width: 162,
                    },
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                Ед.изм.
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workUnit',
                        width: 90,
                    },
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                Участие в суммировании ФО по виду работ
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workInSum',
                        width: 162,
                        renderCell: (row: WorkOrderVersionPriceData) => WorkInSumTitles[row.workInSum],
                    },
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                К перехода
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workRatio',
                        width: 136,
                        renderCell: (row: WorkOrderVersionPriceData) => formatNumberToRu(row.workRatio, 2),
                    },
                    {
                        title: (
                            <ColoredColumnTitle align="center" style={style}>
                                <span>
                                    План <div>(Кол-во)</div>
                                </span>
                            </ColoredColumnTitle>
                        ),
                        accessor: 'workPlan',
                        width: 136,
                        renderCell: (row: WorkOrderVersionPriceData) => formatNumberToRu(row.workPlan, 3),
                    },
                    ...(workOrderStatus === WorkOrderStatusEnum.InProgress
                        ? [
                              {
                                  title: (
                                      <ColoredColumnTitle align="center" style={style}>
                                          <span>
                                              Выполнено <div>(Кол-во)</div>
                                          </span>
                                      </ColoredColumnTitle>
                                  ),
                                  accessor: 'workCompleted',
                                  width: 136,
                                  renderCell: (row: WorkOrderVersionPriceData) =>
                                      formatNumberToRu(row.workCompleted, 3),
                              },
                              {
                                  title: (
                                      <ColoredColumnTitle align="center" style={style}>
                                          <span>
                                              Остаток <div>(Кол-во)</div>
                                          </span>
                                      </ColoredColumnTitle>
                                  ),
                                  accessor: 'workReminder',
                                  width: 136,
                                  renderCell: (row: WorkOrderVersionPriceData) => formatNumberToRu(row.workReminder, 3),
                              },
                          ]
                        : []),
                ],
            },
        ],
        [workOrderStatus],
    );
